/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as Verify2faRouteImport } from './routes/verify-2fa'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DeactivatedRouteImport } from './routes/deactivated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcceptInvitationTokenRouteImport } from './routes/accept-invitation.$token'
import { Route as AuthenticatedTeamRouteImport } from './routes/_authenticated/team'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedContractsIndexRouteImport } from './routes/_authenticated/contracts/index'
import { Route as AuthenticatedContractsNewNdaRouteImport } from './routes/_authenticated/contracts/new-nda'
import { Route as AuthenticatedContractsNewB2bRouteImport } from './routes/_authenticated/contracts/new-b2b'
import { Route as AuthenticatedContractsContractIdRouteImport } from './routes/_authenticated/contracts/$contractId'
import { Route as AuthenticatedContractsContractIdReviewRouteImport } from './routes/_authenticated/contracts/$contractId.review'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const Verify2faRoute = Verify2faRouteImport.update({
  id: '/verify-2fa',
  path: '/verify-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DeactivatedRoute = DeactivatedRouteImport.update({
  id: '/deactivated',
  path: '/deactivated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationTokenRoute = AcceptInvitationTokenRouteImport.update({
  id: '/accept-invitation/$token',
  path: '/accept-invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTeamRoute = AuthenticatedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContractsIndexRoute =
  AuthenticatedContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsNewNdaRoute =
  AuthenticatedContractsNewNdaRouteImport.update({
    id: '/contracts/new-nda',
    path: '/contracts/new-nda',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsNewB2bRoute =
  AuthenticatedContractsNewB2bRouteImport.update({
    id: '/contracts/new-b2b',
    path: '/contracts/new-b2b',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsContractIdRoute =
  AuthenticatedContractsContractIdRouteImport.update({
    id: '/contracts/$contractId',
    path: '/contracts/$contractId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsContractIdReviewRoute =
  AuthenticatedContractsContractIdReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => AuthenticatedContractsContractIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/deactivated': typeof DeactivatedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-2fa': typeof Verify2faRoute
  '/verify-email': typeof VerifyEmailRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/team': typeof AuthenticatedTeamRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/contracts/$contractId': typeof AuthenticatedContractsContractIdRouteWithChildren
  '/contracts/new-b2b': typeof AuthenticatedContractsNewB2bRoute
  '/contracts/new-nda': typeof AuthenticatedContractsNewNdaRoute
  '/contracts/': typeof AuthenticatedContractsIndexRoute
  '/contracts/$contractId/review': typeof AuthenticatedContractsContractIdReviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/deactivated': typeof DeactivatedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-2fa': typeof Verify2faRoute
  '/verify-email': typeof VerifyEmailRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/team': typeof AuthenticatedTeamRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/contracts/$contractId': typeof AuthenticatedContractsContractIdRouteWithChildren
  '/contracts/new-b2b': typeof AuthenticatedContractsNewB2bRoute
  '/contracts/new-nda': typeof AuthenticatedContractsNewNdaRoute
  '/contracts': typeof AuthenticatedContractsIndexRoute
  '/contracts/$contractId/review': typeof AuthenticatedContractsContractIdReviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/deactivated': typeof DeactivatedRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-2fa': typeof Verify2faRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/team': typeof AuthenticatedTeamRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/_authenticated/contracts/$contractId': typeof AuthenticatedContractsContractIdRouteWithChildren
  '/_authenticated/contracts/new-b2b': typeof AuthenticatedContractsNewB2bRoute
  '/_authenticated/contracts/new-nda': typeof AuthenticatedContractsNewNdaRoute
  '/_authenticated/contracts/': typeof AuthenticatedContractsIndexRoute
  '/_authenticated/contracts/$contractId/review': typeof AuthenticatedContractsContractIdReviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/deactivated'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/register'
    | '/reset-password'
    | '/verify-2fa'
    | '/verify-email'
    | '/audit'
    | '/dashboard'
    | '/notifications'
    | '/profile'
    | '/team'
    | '/accept-invitation/$token'
    | '/contracts/$contractId'
    | '/contracts/new-b2b'
    | '/contracts/new-nda'
    | '/contracts/'
    | '/contracts/$contractId/review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/deactivated'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/register'
    | '/reset-password'
    | '/verify-2fa'
    | '/verify-email'
    | '/audit'
    | '/dashboard'
    | '/notifications'
    | '/profile'
    | '/team'
    | '/accept-invitation/$token'
    | '/contracts/$contractId'
    | '/contracts/new-b2b'
    | '/contracts/new-nda'
    | '/contracts'
    | '/contracts/$contractId/review'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/deactivated'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/register'
    | '/reset-password'
    | '/verify-2fa'
    | '/verify-email'
    | '/_authenticated/audit'
    | '/_authenticated/dashboard'
    | '/_authenticated/notifications'
    | '/_authenticated/profile'
    | '/_authenticated/team'
    | '/accept-invitation/$token'
    | '/_authenticated/contracts/$contractId'
    | '/_authenticated/contracts/new-b2b'
    | '/_authenticated/contracts/new-nda'
    | '/_authenticated/contracts/'
    | '/_authenticated/contracts/$contractId/review'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  DeactivatedRoute: typeof DeactivatedRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  Verify2faRoute: typeof Verify2faRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AcceptInvitationTokenRoute: typeof AcceptInvitationTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-2fa': {
      id: '/verify-2fa'
      path: '/verify-2fa'
      fullPath: '/verify-2fa'
      preLoaderRoute: typeof Verify2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deactivated': {
      id: '/deactivated'
      path: '/deactivated'
      fullPath: '/deactivated'
      preLoaderRoute: typeof DeactivatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation/$token': {
      id: '/accept-invitation/$token'
      path: '/accept-invitation/$token'
      fullPath: '/accept-invitation/$token'
      preLoaderRoute: typeof AcceptInvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/team': {
      id: '/_authenticated/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthenticatedTeamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/': {
      id: '/_authenticated/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AuthenticatedContractsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/new-nda': {
      id: '/_authenticated/contracts/new-nda'
      path: '/contracts/new-nda'
      fullPath: '/contracts/new-nda'
      preLoaderRoute: typeof AuthenticatedContractsNewNdaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/new-b2b': {
      id: '/_authenticated/contracts/new-b2b'
      path: '/contracts/new-b2b'
      fullPath: '/contracts/new-b2b'
      preLoaderRoute: typeof AuthenticatedContractsNewB2bRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/$contractId': {
      id: '/_authenticated/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof AuthenticatedContractsContractIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/$contractId/review': {
      id: '/_authenticated/contracts/$contractId/review'
      path: '/review'
      fullPath: '/contracts/$contractId/review'
      preLoaderRoute: typeof AuthenticatedContractsContractIdReviewRouteImport
      parentRoute: typeof AuthenticatedContractsContractIdRoute
    }
  }
}

interface AuthenticatedContractsContractIdRouteChildren {
  AuthenticatedContractsContractIdReviewRoute: typeof AuthenticatedContractsContractIdReviewRoute
}

const AuthenticatedContractsContractIdRouteChildren: AuthenticatedContractsContractIdRouteChildren =
  {
    AuthenticatedContractsContractIdReviewRoute:
      AuthenticatedContractsContractIdReviewRoute,
  }

const AuthenticatedContractsContractIdRouteWithChildren =
  AuthenticatedContractsContractIdRoute._addFileChildren(
    AuthenticatedContractsContractIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedTeamRoute: typeof AuthenticatedTeamRoute
  AuthenticatedContractsContractIdRoute: typeof AuthenticatedContractsContractIdRouteWithChildren
  AuthenticatedContractsNewB2bRoute: typeof AuthenticatedContractsNewB2bRoute
  AuthenticatedContractsNewNdaRoute: typeof AuthenticatedContractsNewNdaRoute
  AuthenticatedContractsIndexRoute: typeof AuthenticatedContractsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedTeamRoute: AuthenticatedTeamRoute,
  AuthenticatedContractsContractIdRoute:
    AuthenticatedContractsContractIdRouteWithChildren,
  AuthenticatedContractsNewB2bRoute: AuthenticatedContractsNewB2bRoute,
  AuthenticatedContractsNewNdaRoute: AuthenticatedContractsNewNdaRoute,
  AuthenticatedContractsIndexRoute: AuthenticatedContractsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  DeactivatedRoute: DeactivatedRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  Verify2faRoute: Verify2faRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AcceptInvitationTokenRoute: AcceptInvitationTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
